import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaArrowUp
} from "react-icons/fa";

function Footer() {

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footer">

      <div className="container">

        <div className="footer-grid">

          {/* Company */}

          <div>

            <h2 className="footer-logo">

              <span>Potech</span> Technologies

            </h2>

            <p>
              Building modern websites, custom software,
              ERP solutions and digital products for
              businesses, schools, hospitals and startups.
            </p>

            <div className="social">

              <a href="#"><FaFacebookF /></a>

              <a href="#"><FaInstagram /></a>

              <a href="#"><FaLinkedinIn /></a>

              <a href="#"><FaYoutube /></a>

              <a href="#"><FaWhatsapp /></a>

            </div>

          </div>

          {/* Quick Links */}

          <div>

            <h3>Quick Links</h3>

            <ul>

              <li><a href="#home">Home</a></li>

              <li><a href="#about">About</a></li>

              <li><a href="#services">Services</a></li>

              <li><a href="#products">Products</a></li>

              <li><a href="#portfolio">Portfolio</a></li>

              <li><a href="#contact">Contact</a></li>

            </ul>

          </div>

          {/* Services */}

          <div>

            <h3>Services</h3>

            <ul>

              <li>Website Development</li>

              <li>Software Development</li>

              <li>Mobile App Development</li>

              <li>ERP Solutions</li>

              <li>Digital Marketing</li>

              <li>SEO Optimization</li>

            </ul>

          </div>

          {/* Contact */}

          <div>

            <h3>Contact</h3>

            <p>Near Z P School, Jamb BK,Tq.Jintur Dist. Parbhani, Maharashtra</p>

            <p>+91 7722000088</p>

            <p>info@potech.in</p>

            <button
              className="top-btn"
              onClick={scrollTop}
            >

              <FaArrowUp />

            </button>

          </div>

        </div>

        <div className="copyright">

          © {new Date().getFullYear()} Potech Technologies.
          All Rights Reserved.

        </div>

      </div>

    </footer>
  );
}

export default Footer;